import { Action, RequestStatus, UseCaseStateGenerator } from '@lib/plugin-redux-core';
import {
  UpdateFormInformationUseCaseState,
  CreateFormThumbnailUseCaseState,
} from './tab-info.states';
import { FormEditPageState } from '../form-edit.states';
import { FormVersionMutationResult, UPDATE_FORM_INFORMATION_USE_CASE } from '@module/form';
import { CREATE_FORM_THUMBNAIL_USE_CASE, CreatedFileStorage } from '@module/file-storage';
import { withSyncedFormVersion } from '../sync-form-version';

export const handleUpdateFormInformationUseCase: UseCaseStateGenerator<UpdateFormInformationUseCaseState> =
  {
    name: UPDATE_FORM_INFORMATION_USE_CASE,
    executing: (state: FormEditPageState): FormEditPageState => {
      return { ...state, updateFormInformationStatus: RequestStatus.EXECUTE };
    },
    success: (state: FormEditPageState, action: Action): FormEditPageState => {
      const { payload } = action;
      const { formVersion } = (payload ?? {}) as FormVersionMutationResult;
      return {
        ...state,
        updateFormInformationStatus: RequestStatus.SUCCESS,
        ...withSyncedFormVersion(state, formVersion),
      };
    },
    error: (state: FormEditPageState, action: Action): FormEditPageState => {
      const { error } = action;
      return {
        ...state,
        error,
        updateFormInformationStatus: RequestStatus.ERROR,
      };
    },
  };

export const handleCreateFormThumbnailUseCase: UseCaseStateGenerator<CreateFormThumbnailUseCaseState> =
  {
    name: CREATE_FORM_THUMBNAIL_USE_CASE,
    executing: (state: FormEditPageState): FormEditPageState => {
      return {
        ...state,
        createFormThumbnailStatus: RequestStatus.EXECUTE,
      };
    },
    success: (state: FormEditPageState, action: Action): FormEditPageState => {
      const { payload } = action;
      return {
        ...state,
        createFormThumbnailStatus: RequestStatus.SUCCESS,
        selectedThumbnailFile: payload as CreatedFileStorage,
      };
    },
    error: (state: FormEditPageState, action: Action): FormEditPageState => {
      const { error } = action;
      return {
        ...state,
        error,
        createFormThumbnailStatus: RequestStatus.ERROR,
      };
    },
    reset: (state: FormEditPageState): FormEditPageState => {
      return {
        ...state,
        selectedThumbnailFile: null,
        createFormThumbnailStatus: RequestStatus.RESET,
      };
    },
  };

export const tabInfoHandlers = [
  handleUpdateFormInformationUseCase,
  handleCreateFormThumbnailUseCase,
];
